import { VestraLogoMark } from "@/components/ui/VestraLogoMark";
import { AnthropicMarkIcon } from "@/components/icons/AnthropicMarkIcon";
import { SUPABASE_CDN } from "./types";

export function ProviderBadge({
  provider,
  creatorName,
  creatorAvatar,
}: {
  provider: "Anthropic" | "Composio" | "Bash";
  creatorName: string;
  creatorAvatar?: string;
}) {
  if (provider === "Anthropic") {
    return (
      <div className="flex items-center gap-1.5">
        <span className="inline-flex items-center justify-center w-4 h-4 rounded bg-skill-resume-page dark:bg-skill-resume-page-2">
          <AnthropicMarkIcon className="w-2 h-2 text-[#e8ddd0] dark:text-[#191919]" />
        </span>
        <span className="text-3 text-fg-muted">Anthropic</span>
      </div>
    );
  }
  if (provider === "Composio") {
    return (
      <div className="flex items-center gap-1.5">
        <span className="inline-flex items-center justify-center w-4 h-4 rounded bg-white dark:bg-white/90">
          <img
            src={`${SUPABASE_CDN}/composio.svg`}
            alt=""
            className="w-2.5 h-2.5"
          />
        </span>
        <span className="text-3 text-fg-muted">Composio</span>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-1.5">
      {creatorAvatar ? (
        <img
          src={creatorAvatar}
          alt=""
          className="w-4 h-4 rounded-full object-cover"
          referrerPolicy="no-referrer"
        />
      ) : (
        <VestraLogoMark size={16} className="rounded" />
      )}
      <span className="text-3 text-fg-muted">{creatorName || "Unknown"}</span>
    </div>
  );
}
